const FenceServices = () => {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Residential Fencing',
      description: 'Custom fence installation for privacy, security, and curb appeal enhancement for El Paso homes.'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Fencing',
      description: 'Durable commercial fencing solutions including security fences, perimeter fencing, and access control.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Fence Repair',
      description: 'Expert fence repair services for damaged panels, posts, gates, and hardware replacement.'
    },
    {
      icon: 'ri-door-line',
      title: 'Gate Installation',
      description: 'Custom gate design and installation including automatic gates, driveway gates, and pedestrian gates.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Fence Staining & Painting',
      description: 'Professional fence staining and painting services to protect and beautify your wood fence.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Security Fencing',
      description: 'High-security fencing solutions with anti-climb features for maximum property protection.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Fence Services in El Paso
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From new fence installation to repairs and maintenance, our network of fence contractors provides complete fencing solutions for every property type and budget.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FenceServices;
